import DashboardPage from "../pages/DashboardPage";
import ManagerPage from "@features/platforms/components/DatabaseManager";

const routes = [];

export default routes;
